

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";

import { useEffect, useRef, useState } from "react";
import { Complementary } from "../../../models/trainer-registration.model";
import trainerRegistration from "../../../services/trainer/trainerRegistration";
import { ExperienceYears } from "../../../utils/years";

export const ComplementaryExperienceModal: React.FC<any> = ({ isOpenComplementaryX, onClosecomplementaryX, isComplementary = false, reload }: { isOpenComplementaryX: any, onClosecomplementaryX: any, isComplementary: boolean, reload: any }) => {

  const cancelRef = useRef().current;
  const [complementary, setComplementary] = useState<Complementary[]>([]);
  const [complementarylist, setComplementarylist] = useState<any[]>([]);
  const [loading, isLoading] = useState(false)
  const [Xyears, setXyears] = useState<any[]>()
  const toast = useToast();


  useEffect(() => {
    setXyears(ExperienceYears)
    trainerRegistration
      .getAllComplementary()
      .then((response) => {
        setComplementary(response.data)
        
      })
      .catch((err) => err);
  }, []);
  const formik = useFormik({
 
    initialValues: {
      cesKnowledge: "",
      resKnowledge: '',
      transferKnowledge: '',
      teachingXperience: '',
      psworkExperience: '',

    },
    onSubmit: async (values) => {
      const complementaryXperience: any = {
        complementry_id: values.cesKnowledge,
        years_of_experience: values.cesKnowledge
      }
      try {
        const basicResponse = await trainerRegistration.updateUserComplimentaryExperience(complementaryXperience);
        if (basicResponse) {
          onClosecomplementaryX()
          reload()
          
          toast({
            title: "Registration",
            description: "Basic Details successful",
            status: "success",
          })

        }
      } catch (error) {

        toast({
          title: "Registration",
          description: "Basic Details successful",
          status: "success",
        })
      }
    }
  })
   
  const addComplementary = (complements:object) => {
  let complementArray :any[] = [];
 complementarylist ? complementArray = [...complementarylist]: complementArray = [];
 complementArray.push(complements)
 setComplementarylist(complementArray)
  }
 const submitcomplementaryExperience = async () => {
  isLoading(true)
  const payload ={
    complementaries: complementarylist
  }
  try {
    const complementaryResponse = await trainerRegistration.updateUserComplimentaryExperience(payload);
    if (complementaryResponse) {
      isLoading(false)
      
      toast({
        title: "Registration",
        description: "Complementary response succesffully added",
        status: "success",
      })
      onClosecomplementaryX();
      reload()

    }
  } catch (error) {

    toast({
      title: "Registration",
      description: "something went wrong",
      status: "error",
    })
  }
 }

  return (
    <>
      <Modal
        isOpen={isOpenComplementaryX && isComplementary}
        onClose={onClosecomplementaryX}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Flex justifyContent='center'>
              <Box>
                <Flex justifyContent='center'>
                  <Text mx='auto' color="#353535" fontSize="20px" fontWeight='800'>
                    Complementary Experience
                  </Text>
                </Flex>

              </Box>
            </Flex>

          </ModalHeader>
          <ModalCloseButton size="sm" />

          <ModalBody>
            <Box mt={4}>
              <Text color='#9E9E9E' fontSize="14px">You must select a value for each experience criteria
              </Text>

              <form onSubmit={formik.handleSubmit} >
                {
                  complementary.map((each, index) => (
                    <FormControl key={index} mb='26px'  >
                      <FormLabel fontWeight="700" color="#616161" fontSize='14px'>{each.name}</FormLabel>
                      <Select variant="outline" bg="inputText.500" size="sm" placeholder="Select Years"  name={each.name} onChange={(e) => {addComplementary({'complementary_id': each.id,'years_of_experience': e.target.value,'remark': 'Good'})}} fontSize='14px' color="brand.subtitle" >
                        {
                          Xyears && Xyears.map(each => <option key={each} value={each}> {each} </option>)
                        }
                      </Select>

                    </FormControl>

                  ))
                }






                <Flex mt={12} justifyContent="end">
                  <HStack>
                    {/* <Button size="sm" px={6} fontSize={12} ref={cancelRef} onClick={() => onClosecomplementaryX()}>
                      Cancel
                    </Button> */}
                    <Button colorScheme="red" isLoading={loading}  onClick={() => {submitcomplementaryExperience()}}
                      size="sm" px={6} fontSize={12} >SAVE CHANGES</Button>
                  </HStack>
                </Flex>
              </form>

            </Box>


          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
